/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf1
 */
export interface BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf1
     */
    'cardType': BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf1CardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf1
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf1
     */
    'isRenewalProcessing': boolean;
}

export const BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf1CardTypeEnum = {
    physical: 'physical'
} as const;

export type BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf1CardTypeEnum = typeof BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf1CardTypeEnum[keyof typeof BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf1CardTypeEnum];


